import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { RollLayoutDocument } from "../models/RollLayout";

export interface GetRollLayoutsParams {
	standNumber: number;
	signal?: AbortSignal;
}

export const getRollLayouts = async ({
	standNumber,
	signal,
}: GetRollLayoutsParams): Promise<RollLayoutDocument[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StandNumber", value: standNumber },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetRollLayouts]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching roll layout documents");
	}
	return get(resp, "data.tables[0].rows", []) as RollLayoutDocument[];
};
